import type { OfertaEndesaModel } from "@api/api";

export class DatosOfertaEndesa implements OfertaEndesaModel {
    Miscelanea: string = '';
    CodigoAnexo: string | null = null;
}